export default __webpack_public_path__ + "static/media/caracter_height.8b2d6c25.svg";